import moment from 'moment';
import numeral from 'numeral';
import _ from 'lodash';

import { YOUTUBE_URL, IMAGE_URL, FILE_URL, DOC_URL, PDF_URL, TEXT_CONTENT } from './static-configuration';
import { extractYoutubeVideoID } from './asset-url-helper-service';

// Promise based timeout
export function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function getInfluencerFromOrganisations(organisations) {
  if (organisations) {
    const isDiscussionOrganisation = organisation => organisation.influencer !== null;
    const discussionOrganisation = _.find(organisations, isDiscussionOrganisation);
    const influencer = discussionOrganisation && discussionOrganisation.influencer;
    return influencer;
  }
  return null;
}

export function getDate(dateSent) {
  const today = moment();
  // let yesterday = moment().subtract(1, 'day');

  if (moment(dateSent).isSame(today, 'day')) {
    const endDate = moment(dateSent).format('HH:mm');
    return `Today, ${endDate}`;
  }
  return moment(dateSent).format('ddd D MMM, HH:mm');
}

export function round(value, precision) {
  const multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

export function roundNumberToSmallestDecimal(number, precision) {
  if (precision >= 10 || !number) return 0; // Requires number and high precision means number is too small
  const roundedNumber = round(number, precision);
  return roundedNumber || roundNumberToSmallestDecimal(number, precision + 1);
}

export function dyzioEngagementScore(likeCount, dislikeCount, commentCount, viewCount) {
  const likePercentage = (likeCount / viewCount) * 100;
  const dislikePercentage = (dislikeCount / viewCount) * 100;
  const commentPercentage = (commentCount / viewCount) * 100;

  const COMMENT_WEIGHTING = 50;
  const COMMENT_WEIGHTING_PERCENTAGE = 1;
  const LIKE_WEIGHTING = 50;
  const LIKE_WEIGHTING_PERCENTAGE = 5;

  const commentEngagementScore = commentCount ? round(((commentPercentage / COMMENT_WEIGHTING_PERCENTAGE) * COMMENT_WEIGHTING)) : 0;
  const likeEngagementScore = likeCount && dislikeCount ? round((((likePercentage - dislikePercentage) / LIKE_WEIGHTING_PERCENTAGE) * LIKE_WEIGHTING)) : 0;
  const dyzioEngagementScore = commentEngagementScore + likeEngagementScore;
  return dyzioEngagementScore;
}

export function isAnImageFile(filePath) {
  if (!filePath) return false;
  return (/\.(gif|jpg|jpeg|tiff|png)$/i).test(filePath);
}

export function isPdfFile(filePath) {
  if (!filePath) return false;
  return _.includes(filePath.toLowerCase(), '.pdf');
}

export function isWordFile(filePath) {
  if (!filePath) return false;
  return _.includes(filePath.toLowerCase(), '.doc');
}

export function getFileType(filePath) {
  if (extractYoutubeVideoID(filePath)) return YOUTUBE_URL;
  if (isAnImageFile(filePath)) return IMAGE_URL;
  if (isPdfFile(filePath)) return PDF_URL;
  if (isWordFile(filePath)) return DOC_URL;
  return FILE_URL;
}

export function getMostRecentDocument(deliverable) {
  let highestVersionDocument = null;
  let currentHighestVersion = 0;
  if (deliverable.documents && deliverable.documents[0]) {
    deliverable.documents.forEach(document => {
      if (document.version > currentHighestVersion) {
        highestVersionDocument = document;
        currentHighestVersion = document.version;
      }
    });
  }
  return highestVersionDocument || deliverable.document;
}



/** WEBPACK FOOTER **
 ** ./src/utils/helper-functions.js
 **/